import React, { useState, useEffect, useContext, Component } from "react";
import {HeaderDynamic} from '../pages/HeaderDynamic'
// import {Helmet} from "react-helmet";
import {customHelmet,customManifest, ElmentShow,ContactIconBar} from '../config/projectConfig';
import {withRouter, RouteComponentProps, useParams} from "react-router-dom";
// import App from "../App";
import {RouterContext} from '../CustomBrowserRouter';

// import { getIdFromPath, getDoc, getDocById, updateDocById, noImage, uploadImageDynamic } from '../config/projectConfig';
import {Button, Row, Container, Col, Form, Table, InputGroup, OverlayTrigger, Tooltip} from 'react-bootstrap';

import { AuthUserContext } from '../components/Session'
import { withFirebase } from '../components/Firebase';
import { loadMaster, dateFormat, uploadImage, getCol, getColById, getDoc, getDocById ,uploadImageDynamic } from '../config/dbUtils'
import { LabelTextInput, LabelImageInput, TextInput, ImageInput } from '../config/formUtils'

import ContactInput from './ContactInput';

const PageFunction = (props) => {
  const firebase = props.firebase;
  const firestore = props.firebase.firestore;
  const collection = firestore.collection("website");
  
  const [inputList, setInputList] = useState([]); 
    const [company, setCompany] = useState({}); 
    const [companyId, setCompanyId] = useState(); 
    const [helmet, setHelmet] = useState({}); 
    useEffect(() => {
      getWebsite(props.match.params.id);
    },[]);
    const contact = 
    { 
        phone: { contact_id: company.phone} 
        ,facebook: { contact_id: company.facebook, name: "wegetcompany" } 
        ,line: { contact_id: company.line, name: "@wegetcompany" } 
        ,instagram: { contact_id: company.instagram, name: "wegetcompany" } 
        ,twitter: { contact_id: company.twitter, name: "wegetcompany" } 
        ,youtube: { contact_id: company.youtube, name: "wegetcompany" } 
        ,linkedin: { contact_id: company.linkedin, name: "wegetcompany" } 
      }

    const getWebsite = async (webName) => {
      var result = {};
      var websiteCol = firestore.collection("website");
      websiteCol.where("name","==",webName)
      .get().then((snapshot) => {
        snapshot.forEach((doc) => {
          var website = doc.data();
          result = {...result,[doc.id]:website};
          websiteCol.doc(doc.id).collection("helmet").get().then((snap)=>{
            snap.forEach((doc)=>{
              console.log("helmet = >>>>>>>  ", JSON.stringify(doc.data()) );
              setHelmet(doc.data());
            })
          })
          console.log("doc.id = ",doc.id)
          getDocById(firebase, setCompany, setCompanyId, "company", website.id_company);
          // website.doc(data.id_website).collection("company").get().then((s)=>{
          //   s.forEach((doc)=>{
          //     console.log("helmet = >>>>>>>  ", doc.data());
          //     setHelmet(doc.data());
          //   })
          // })
        });
        console.log("result = ",JSON.stringify(result));
        Object.keys(result).forEach((key)=>{
          var idDynamic = result[key].element;
          getDynamicDocById(idDynamic);
        })
      });
    }
    const getDynamicDocById = (key) => {
      firestore.collection("dynamic")
      .doc(key)
      .get().then((doc) => {
        setInputList(...inputList, doc.data().inputList);
      })
    }
    const manifest = "data:application/manifest+json,"+ JSON.stringify(customManifest(helmet.favicon,helmet.logo192,helmet.logo512,"ABC","ABC Jewel & Watch"));
    const projectName = "";
  return (
      <div className="App">
        {/* {JSON.stringify(company)} */}
        <HeaderDynamic projectName={projectName} menu={inputList} logo={ company ? company.companyLogo : false}/>
        {customHelmet(
          company.companyIcon
          ,helmet.logo192
          ,helmet.logo512
          ,manifest
          ,helmet.title
          ,helmet.keywords
          ,helmet.description
          ,helmet.author
          ,helmet.url)
        }
        {/* {customHelmet(
          helmet.favicon
          ,helmet.logo192
          ,helmet.logo512
          ,manifest
          ,helmet.title
          ,helmet.keywords
          ,helmet.description
          ,helmet.author
          ,helmet.url)
        } */}
        {/* <Helmet>
          <meta charSet="utf-8" />
          <title>My Title</title>
          <link rel="canonical" href="http://mysite.com/example" />
      </Helmet> */}
      <div>
          {inputList.map((item, i) => {
            return( <ElmentShow key={i} i={i} item={item} /> )
          }) }
      </div>
      <ContactIconBar contact={ contact } />
      <ContactInput />
  </div>
  );
}
class WebShow extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
        <PageFunction {...this.props} firebase={this.props.firebase} />
    );
  }
}

export default withFirebase(WebShow);